import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import DropdownActivator from 'scaleflow/utils/dropdown-activate';
import nameSort from 'scaleflow/utils/nameSort';

export default class IdeasTableCellDepartmentComponent extends DropdownActivator {
  @service store;
  @tracked departmentFormIsVisible = false;
  selectedIdea = null;

  get idea() {
    return this.args.idea;
  }

  @action
  handleDepartmentsChange(idea, e) {
    const departments = e.map((id) => this.store.peekRecord('department', id));
    idea.departments = departments;
    idea.save();
  }

  @action
  toggleDepartmentForm(idea, val) {
    if (idea) this.selectedIdea = idea;
    else this.selectedIdea = null;
    if (val !== undefined) this.departmentFormIsVisible = val;
    else this.departmentFormIsVisible = !this.departmentFormIsVisible;
  }

  @action
  async onDepartmentAdded(department) {
    const departments = [...this.selectedIdea.departments.content];
    departments.push(department);
    this.selectedIdea.departments = departments;
    await this.selectedIdea.save();
  }

  get departmentsList() {
    const departments = this.store.peekAll('department').map((item) => ({
      value: item.id,
      label: item.name,
    }));
    return departments;
  }

  get sortedDepartments() {
    return this.idea.departments?.content?.toSorted((a, b) =>
      nameSort(a.name, b.name, 'asc'),
    );
  }

  get firstDepartment() {
    return this.sortedDepartments?.[0];
  }

  willDestroy() {
    this.departmentFormIsVisible = false;
    this.selectedIdea = null;
    super.willDestroy(...arguments);
  }
}
